export function isLayerSpec(spec) {
  return spec['layer'] !== undefined;
}